import React, { useCallback, useState, useEffect, useContext, useRef } from 'react'
import { TenantContext } from '../../tenant/TenantContext';
import { API } from '../../api/API';
import { extractError } from '../../api/ErrorUtil';
import { BUSINESS_SPONSORS, SPONSORSHIPS_URL, PAGE_SIZE } from 'config/config';
import { Table, Button, Modal, Row, Col, Form, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faTrash, faArrowRight, faArrowLeft, faCheck, faFileDownload, faRefresh, faUpload } from '@fortawesome/free-solid-svg-icons';
import { FormContainer } from 'uiwidgets/FormContainer';
import { formatCurrency } from 'util/Currency';
import { formatDate } from 'util/Date';
import { evenRound } from 'util/NumberUtils';
import { splitCamelCase, camelCase } from 'util/StringUtils';
import { FilesField } from 'uiwidgets/FilesField';
import { FormField } from '../../uiwidgets/FormField';
import { containsAlphaNumAndSpaceOnly } from 'util/Validators';
import _ from "lodash";
import { SubmitButton } from 'uiwidgets/SubmitButton';
import { getRecipientTypes } from 'util/Lookup';
import { getRecurringFrequency } from 'util/Lookup';
import { getSponsorshipTypes } from 'util/Lookup';
import { getSponsorshipStatus } from 'util/Lookup';
import { isDateGreaterThanToday,isFirstDateLesserThanSecondDate } from 'util/Validators';
import { isValidDate } from 'util/Validators';
import { stringToDateEndOfDayUTC,stringUTCToLocalString,addOneYear } from 'util/Date';


const BusinessSponsors = () => {

    const initialState = {
        errors: {},
        infoMessage: "",
        sponsorships: [],
        totalPages: 0,
        currentPage: 0,
        keyword: "",
        endDate: ""
    };

    const initialValidationState = {
        fileErrMsg: "",
        fileError: false,
        titleErrMsg: "",
        titleError: false,
        endDateError: false,
        endDateErrMsg: ""
    }

    let [formData, setFormData] = useState(initialState);
    let [formValidityData, setFormValidityData] = useState(initialValidationState);
    const { businessConfig } = useContext(TenantContext);
    const [processingSponsorshipId, setProcessingSponsorshipId] = useState(null);
    const spsDocFileInput = useRef(null);

    const onToastClose = () => {
        setFormData({
            ...formData,
            infoMessage: "",
            errors: {}
        });
    }

    const [showSponsorshipContent, setShowSponsorshipContent] = useState({ show: false, contents: [] });
    const handleSponsorshipContentClose = () => {
        fetchBusinessSponsors();
        setShowSponsorshipContent({ show: false, contents: [] });
    }
    const handleSponsorshipContentShow = async (sponsorship) => {
        try {
            let spContentResp = await API.get(SPONSORSHIPS_URL + "/" + sponsorship.sponsorshipId + "/content");
            setShowSponsorshipContent({ show: true, contents: spContentResp.data, sponsorship: sponsorship });
        } catch (error) {
            let { message, errors, httpStatus } = extractError(error);
            if (httpStatus === 404) {
                setShowSponsorshipContent({ show: true, contents: [], sponsorship: sponsorship });
                setFormData({ ...formData, errors: {} });
            } else {
                setFormData({ ...formData, errors: { message, errors, httpStatus } });
            }
        }
    }

    const [showSponsorshipRenewal, setShowSponsorshipRenewal] = useState({ show: false, sponsorship: { endDate: "" } });
    const handleSponsorshipRenewalClose = () => {
        setShowSponsorshipRenewal({ show: false, sponsorship: {} });
    }
    const handleSponsorshipRenewalShow = async (sponsorship) => {
        setFormData({
            ...formData,
            endDate: addOneYear(stringUTCToLocalString(sponsorship.endDate))
        })
        setShowSponsorshipRenewal({ show: true, sponsorship: sponsorship });
    }


    const getBusinessSponsors = async () => {
        let businessSponsorships = await API.get(BUSINESS_SPONSORS,
            { params: { size: PAGE_SIZE, page: formData.currentPage, keyword: formData.keyword } });
        return { sponsorships: businessSponsorships.data.content, totalPages: businessSponsorships.data.totalPages }
    }
    const fetchBusinessSponsors = useCallback(async () => {
        try {
            let { sponsorships, totalPages } = await getBusinessSponsors();
            setFormData({
                ...formData,
                sponsorships: sponsorships,
                totalPages: totalPages
            })
        } catch (error) {
            let { message, errors, httpStatus } = extractError(error);
            if (httpStatus === 404) {
                setFormData({ ...formData, sponsorships: [], totalPages: 0, infoMessage: "No sponsors were found" });
            } else {
                setFormData({ ...formData, sponsorships: [], totalPages: 0, errors: { message, errors, httpStatus } });
            }
        }
    })
    useEffect(() => {
        fetchBusinessSponsors();
    }, [formData.currentPage]);

    useEffect(() => {
        if (formData.keyword.length > 3) {
            fetchBusinessSponsors();
        }
    }, [formData.keyword]);

    const [showRecipientDetails, setShowRecipientDetails] = useState({ show: false, sponsorship: {} });
    const handleRecipientDetailsClose = () => setShowRecipientDetails({ show: false, sponsorship: {} });
    const handleRecipientDetailsShow = (sponsorship) => {
        setShowRecipientDetails({ show: true, sponsorship: sponsorship });
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
    }

    const handlePaging = async (page) => {
        if (page < 0) {
            alert("Reached the beginning of data set")
            page = 0;
        }
        if (page > formData.totalPages - 1) {
            alert("Reached the end of data set")
            page = formData.totalPages - 1;
        }
        setFormData({
            ...formData,
            currentPage: page
        })
    }

    const handleFilter = async (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setFormData({
            ...formData,
            [name]: value
        });
    }

    const handleFilterKeyDown = async (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            fetchBusinessSponsors();
        }
    };

    const deleteSponsorship = async (event, sponsorship) => {

        let deleteSponsorship = window.confirm("Are you sure you want to delete the sponsorship. This will remove the recurring payment and will reopen sponsoship for this recipient");
        if (deleteSponsorship) {
            try {
                let resp = await API.delete(BUSINESS_SPONSORS + "/" + sponsorship.sponsorId);
                let { sponsorships, totalPages } = await getBusinessSponsors();
                setFormData({
                    ...formData,
                    sponsorships: sponsorships,
                    totalPages: totalPages,
                    infoMessage: resp?.data?.message
                })
            }
            catch (error) {
                let { message, errors, httpStatus } = extractError(error);
                if (httpStatus === 404) {
                    setFormData({ ...formData, sponsorships: [], infoMessage: "No sponsors were found" });
                } else {
                    setFormData({ ...formData, errors: { message, errors, httpStatus } });
                }
            }
        }
    }

    const fulfilSponsorship = async (event, sponsorship) => {
        try {
            await API.put(SPONSORSHIPS_URL + "/" + sponsorship.sponsorshipId + "/fulfill");
            let { sponsorships, totalPages } = await getBusinessSponsors();
            setFormData({
                ...initialState,
                editMode: false,
                sponsorships: sponsorships,
                totalPages: totalPages,
                infoMessage: "The sponsorship was marked as fulfilled successfully"
            });
        } catch (error) {
            let { message, errors, httpStatus } = extractError(error);
            if (httpStatus === 404) {
                setFormData({ ...formData, sponsorships: [], totalPages: 0, infoMessage: "No sponsorships were found" });
            } else {
                setFormData({ ...formData, errors: { message, errors, httpStatus } });
            }
        }
    }

    const downloadSponsorshipContent = async (evt, spsContent) => {
        evt.preventDefault();
        await API.get(SPONSORSHIPS_URL + "/content/" + spsContent.id + "/download", { responseType: "blob" })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", camelCase(spsContent.title) + ".pdf");
                document.body.appendChild(link);
                link.click();
            }).catch(err => {
                let { message, errors, httpStatus } = extractError(err);
                if (httpStatus === 404) {
                    setFormData({ ...formData, infoMessage: "No sponsorship documents were found" });
                } else {
                    setFormData({ ...formData, errors: { message, errors, httpStatus } });
                }
            });
    }

    const handleChange = async (event) => {
        if (formData.readOnly) {
            return;
        }
        const name = event.target.name;
        const value = event.target.value;
        setFormData({
            ...formData,
            [name]: value
        })
    }

    const handleFileChange = async (event) => {
        if (formData.readOnly) {
            return;
        }
        const value = event.target.files[0];
        setFormData({
            ...formData,
            file: value,
        })
    };

    const handleSponsorshipEndDateChange = async (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setFormData({
            ...formData,
            [name]: value
        })
    }

    const handlSponsorshipEndDateFormValidation = async (event, endDate) => {
        const name = event.target.name;
        const value = event.target.value;
        let { hasError, error } = validateInput(name, value, endDate);
        setFormValidityData({
            ...formValidityData,
            [name + 'Error']: hasError,
            [name + 'ErrMsg']: error
        })
    }


    const validateInput = (name, value, endDate) => {
        let hasError = false, error = ""
        switch (name) {
            case "endDate":
                if (value.trim() === "") {
                    hasError = true;
                    error = "End Date cannot be empty";
                } else if (!isValidDate(value)) {
                    hasError = true;
                    error = "End Date is invalid"
                } else if (!isDateGreaterThanToday(value)) {
                    hasError = true;
                    error = "End Date must be greater than todays date"
                } else if (endDate && !isFirstDateLesserThanSecondDate(endDate, value)) {
                    hasError = true;
                    error = "End Date must be greater than current end date"
                } else {
                    hasError = false;
                    error = "";
                }
                break;
            case "title":
                if (!value || value.trim() === "") {
                    hasError = true
                    error = "Title cannot be empty"
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Invalid Title. Only alphbets are allowed";
                } else {
                    hasError = false
                    error = ""
                }
                break;
            case "fileSize":
                if (!value) {
                    hasError = true;
                    error = "File is required"
                } else if (value > 300 * 1024) {
                    hasError = true;
                    error = "File sze cannot be greater than 300k"
                }

                break;
            default:
                break;
        }
        return { hasError, error };
    }

    const handleValidation = async (event) => {
        const name = event.target.name;
        const value = event.target.value;
        let { hasError, error } = validateInput(name, value);
        setFormValidityData({
            ...formValidityData,
            [name + 'Error']: hasError,
            [name + 'ErrMsg']: error
        })
    }

    const handleFileValidation = async (event) => {
        if (!formData.file) {
            return;
        }
        let { hasError, error } = validateInput("fileSize", formData.file.size)

        setFormValidityData({
            ...formValidityData,
            fileError: hasError,
            fileErrMsg: error
        })
    }

    const handleSponsorshipDocumentUpload = async (event, sponsorship) => {
        event.preventDefault();

        let titleValState = validateInput('title', formData.title);
        let fileValState = validateInput('fileSize', formData?.file?.size);
        if (titleValState.hasError || fileValState.hasError) {
            setFormValidityData({
                ['titleError']: titleValState?.hasError,
                ['titleErrMsg']: titleValState?.error,
                ['fileError']: fileValState?.hasError,
                ['fileErrMsg']: fileValState?.error
            });
            alert("Form has validation errors");
            return false;
        }

        try {
            const postData = new FormData();
            postData.append('file', formData.file);
            postData.append('title', formData.title);

            await API.post(SPONSORSHIPS_URL + "/" + sponsorship.sponsorshipId + "/content", postData);
            let spContentResp = await API.get(SPONSORSHIPS_URL + "/" + sponsorship.sponsorshipId + "/content");
            setShowSponsorshipContent({ show: true, contents: spContentResp.data, sponsorship: sponsorship });

            //reset data
            setFormData({
                ...formData,
                title: "",
                file: null,
                infoMessage: "Document added successfully"

            })
            if (spsDocFileInput.current) {
                spsDocFileInput.current.value = "";
                spsDocFileInput.current.type = "file";
            }
        } catch (error) {
            let { message, errors, httpStatus } = extractError(error);
            if (httpStatus === 404) {
                setShowSponsorshipContent({ show: true, contents: [], sponsorship: sponsorship });
                setFormData({ ...formData, infoMessage: "No sponsorship documents were found" });
            } else {
                setFormData({ ...formData, errors: { message, errors, httpStatus } });
            }
        }

    }

    const deleteSponsorshipDocument = async (event, spContent) => {
        event.preventDefault();
        try {
            await API.delete(SPONSORSHIPS_URL + "/content/" + spContent.id)
            let spContentResp = await API.get(SPONSORSHIPS_URL + "/" + spContent.sponsorshipId + "/content");
            setShowSponsorshipContent({ ...showSponsorshipContent, contents: spContentResp.data });
        } catch (error) {
            let { message, errors, httpStatus } = extractError(error);
            if (httpStatus === 404) {
                setShowSponsorshipContent({ ...showSponsorshipContent, contents: [] });
                setFormData({ ...formData, infoMessage: "No sponsorship documents were found", errors: {} });
            } else {
                setFormData({ ...formData, errors: { message, errors, httpStatus } });
            }
        };
    }

    const renewSponsorship = async (evt, sponsorship) => {

        try {
            evt.preventDefault();
            let { hasError, error } = validateInput("endDate", formData.endDate, stringUTCToLocalString(sponsorship.endDate));
            if (hasError) {
                setFormValidityData({
                    ...formValidityData,
                    endDateError: hasError,
                    endDateErrMsg: error
                })
                return;
            }
            //call API
            setProcessingSponsorshipId(sponsorship.id);
            await API.put(BUSINESS_SPONSORS + "/" + sponsorship.sponsorId, {
                endDate: stringToDateEndOfDayUTC(formData.endDate)
            });
            let { sponsorships, totalPages } = await getBusinessSponsors();
            setFormData({
                ...initialState,
                editMode: false,
                sponsorships: sponsorships,
                totalPages: totalPages,
                infoMessage: "The sponsorship was renewed successfully"
            });
            setProcessingSponsorshipId(null)
            handleSponsorshipRenewalClose();
        } catch (error) {
            setProcessingSponsorshipId(null)
            let { message, errors, httpStatus } = extractError(error);
            if (httpStatus === 404) {
                setFormData({ ...formData, errors: { message: "Sponsorship was not found!" } });
            } else {
                setFormData({ ...formData, errors: { message, errors, httpStatus } });
            }
        }
    }


    return (
        <>
            <FormContainer title="Sponsors" submitButtonFunction={handleSubmit} toastCloseFunc={onToastClose} errors={formData.errors}
                infoMessage={formData.infoMessage} >
                <Row>
                    <Col mb={4} lg={4} sm={6}><Form.Control name="keyword" label="Keyword Filter" placeholder="Keyword Filter" type="text" onChange={handleFilter}
                        onBlur={handleFilter} value={formData.keyword} onKeyDown={handleFilterKeyDown} />
                    </Col>
                    {!_.isEmpty(formData.sponsorships) &&
                        <Col className='d-flex justify-content-end'>
                            <Button variant="dark" className="border-0 text-dark" onClick={(event) => { handlePaging(formData.currentPage - 1) }}>
                                <h6><FontAwesomeIcon icon={faArrowLeft} />Previous Page</h6>
                            </Button>
                            &nbsp;<span className="border-0 text-dark btn"><h6>{formData.currentPage + 1} of {formData.totalPages}</h6></span>
                            &nbsp;<Button variant="dark" className="border-0 text-dark" onClick={(event) => { handlePaging(formData.currentPage + 1) }}>
                                <h6>Next Page<FontAwesomeIcon icon={faArrowRight} /></h6>
                            </Button>
                        </Col>}
                </Row>

                <Table className="table-hover table-striped">
                    <thead>
                        <tr>
                            <th>Sponsor</th>
                            <th> Title</th>
                            <th className="border-0">Amount</th>
                            <th className="border-0">Sponsorship Date</th>
                            <th className="border-0">End Date</th>
                            <th className="border-0">Frequency</th>
                            <th className="border-0">Sponsorship Type</th>
                            <th className="border-0">Recipient Type</th>
                            <th className="border-0">Status</th>
                            <th className="border-0">Recipient Code</th>
                            <td className="border-0">Documents</td>
                            <th className="border-0" width="50px">Delete Sponsorhip</th>
                            <th className="border-0" width="50px">Fulfill Sponsorhip</th>
                            <th className="border-0" width="50px">Renew Sponsorhip</th>

                        </tr>

                    </thead>
                    <tbody>
                        {formData.hasOwnProperty('sponsorships') && formData.sponsorships.map((sponsorship, idx) => {
                            let rowStyle = {};
                            if (sponsorship.status === 'PENDING_APPROVAL') {
                                rowStyle = { backgroundColor: '#D3D3D3', color: '#ffffff', pointerEvents: 'none', cursor: 'not-allowed' };
                            }
                            return (
                                <tr key={idx} style={rowStyle}>
                                    <td>{sponsorship.sponsorEmailAddress}</td>
                                    <td>{sponsorship.title}</td>
                                    <td>{formatCurrency(evenRound(sponsorship.amountSponsored / 100, 2), businessConfig.locale, businessConfig.currency)}</td>
                                    <td>{formatDate(sponsorship.sponsorshipDate)}</td>
                                    <td>{formatDate(sponsorship.endDate)}</td>
                                    <td>{getRecurringFrequency(sponsorship.frequency)}</td>
                                    <td>{getSponsorshipTypes(sponsorship.sponsorshipType)}</td>
                                    <td>{getRecipientTypes(sponsorship.recipientType)}</td>
                                    <td>{getSponsorshipStatus(sponsorship.status)}</td>
                                    <td>
                                        <Button variant="link" className="border-0 text-dark" onClick={evt => handleRecipientDetailsShow(sponsorship)}>
                                            {sponsorship.sponsorshipAttributes[Object.keys(sponsorship.sponsorshipAttributes)[0]]}
                                        </Button>
                                    </td>
                                    <td>
                                        <Button variant="dark" className="border-0 text-dark" onClick={event => handleSponsorshipContentShow(sponsorship)}>
                                            {sponsorship.hasContent && <FontAwesomeIcon icon={faFilePdf} />}
                                            {!sponsorship.hasContent && <FontAwesomeIcon icon={faUpload} />}
                                        </Button>
                                    </td>
                                    <td>
                                        {sponsorship.status === 'SPONSORED' && sponsorship.sponsorshipType === 'RECURRING' &&
                                            <Button variant="dark" className="border-0 text-dark" onClick={evt => deleteSponsorship(evt, sponsorship)}>
                                                <FontAwesomeIcon icon={faTrash} />
                                            </Button>}
                                    </td>
                                    <td>{sponsorship.status === 'SPONSORED' && sponsorship.sponsorshipType === 'RECURRING' && <Button variant="dark" className="border-0 text-dark" onClick={evt => fulfilSponsorship(evt, sponsorship)}>
                                        <FontAwesomeIcon icon={faCheck} />
                                    </Button>}
                                        {sponsorship.status === 'FULFILLED' && <span>Fulfilled</span>}
                                    </td>
                                    <td>
                                        {(processingSponsorshipId === sponsorship.id) ? (
                                            <Spinner
                                                style={{ marginBottom: 27 }}
                                                animation="border"
                                                variant="success"
                                            />) : (<>
                                                <Button variant="dark" className="border-0 text-dark" onClick={event => handleSponsorshipRenewalShow(sponsorship)}>
                                                    <FontAwesomeIcon icon={faRefresh} />
                                                </Button>
                                            </>)}

                                    </td>

                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
                <Modal show={showRecipientDetails.show} onHide={handleRecipientDetailsClose}>
                    <Modal.Header closeButton />
                    <Modal.Body>
                        <Table>
                            <tbody>
                                <tr>
                                    {showRecipientDetails.sponsorship?.mediaType &&
                                        <td>
                                            <img src={process.env.REACT_APP_BASE_API_URL + SPONSORSHIPS_URL + '/' + showRecipientDetails.sponsorship.sponsorshipId + '/img'} />
                                        </td>}

                                    <td>
                                        {showRecipientDetails.sponsorship.sponsorshipAttributes && Object.entries(showRecipientDetails.sponsorship.sponsorshipAttributes).map(([key, value]) => (
                                            <React.Fragment key={key}>
                                                <strong key={key}>{splitCamelCase(key)}:</strong> {value} <br />
                                            </React.Fragment>
                                        ))}
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </Modal.Body>
                </Modal>
                <Modal show={showSponsorshipRenewal.show} onHide={handleSponsorshipRenewalClose}>
                    <Modal.Header closeButton><b>Sponsorship Renewal</b></Modal.Header>
                    <Modal.Body>
                        <FormContainer title="Renew Sponsorship"
                            submitButtonFunction={event => renewSponsorship(event, showSponsorshipRenewal.sponsorship)}>
                            <Row>
                                <Col sm={12} mb={6} lg={6}>
                                    <FormField name="endDate" label="Sponsorship End Date" type="date" value={formData.endDate}
                                        placeholder="Sponsorship End Date" onChange={handleSponsorshipEndDateChange} onBlur={(event) => handlSponsorshipEndDateFormValidation(event, stringUTCToLocalString(showSponsorshipRenewal.sponsorship?.endDate))}
                                        valstate={!formValidityData.endDateError} valMsg={formValidityData.endDateErrMsg}
                                        readOnly={formData.readOnly} />
                                </Col>
                            </Row>
                            <Row><Col>&nbsp;</Col></Row>
                            <Row>
                                <Col>
                                    <SubmitButton label="Renew Sponsorship" />
                                </Col>
                            </Row>
                        </FormContainer>

                    </Modal.Body>
                </Modal>
            </FormContainer>
            <Modal show={showSponsorshipContent.show} onHide={handleSponsorshipContentClose}>
                <Modal.Header closeButton><b>Sponsorship Documents</b></Modal.Header>
                <Modal.Body>
                    <FormContainer title="Upload Documents" submitButtonFunction={event => handleSponsorshipDocumentUpload(event, showSponsorshipContent.sponsorship)}>
                        <FormField name="title" label="Title" type="text" value={formData.title}
                            placeholder="Title" onChange={handleChange} onBlur={handleValidation}
                            valstate={!formValidityData.titleError} valMsg={formValidityData.titleErrMsg}
                            readOnly={formData.readOnly} />
                        <FilesField name="file" label="Document" placeholder="File" accept="application/pdf" onChange={handleFileChange}
                            rref={spsDocFileInput} onBlur={handleFileValidation}
                            valstate={!formValidityData.fileError} valMsg={formValidityData.fileErrMsg} />

                        <SubmitButton label="Upload File" />
                    </FormContainer>
                    {showSponsorshipContent.contents && showSponsorshipContent.contents.map((content, idx) => (
                        <Row key={idx}><Col>
                            <Button variant="dark" className="border-0 text-dark" onClick={event => { downloadSponsorshipContent(event, content) }}>
                                <FontAwesomeIcon icon={faFileDownload} />&nbsp;{content.title}
                            </Button>
                        </Col>
                            <Col>
                                <Button variant="dark" className="border-0 text-dark" onClick={event => deleteSponsorshipDocument(event, content)}>
                                    <FontAwesomeIcon icon={faTrash} />
                                </Button>
                            </Col>
                        </Row>

                    ))}


                </Modal.Body>
            </Modal>
        </>
    )
}

export default BusinessSponsors